import { IconChevron } from "components/Icons";
import { Link } from "components/Link";
import styles from "./StrongLink.module.css";

export const StrongLink = ({ link, children, ...rest }) => {
  const { link_type, type, uid, url } = link;

  return (
    <Link
      className={styles.strongLink}
      {...{ link_type, type, uid, url }}
      {...rest}
    >
      <span className={styles.strongLinkInner}>
        <span>{children}</span>
        <IconChevron />
      </span>
    </Link>
  );
};
